export default {
  classic: 'btn waves-effect waves-light',
  basic: 'btn waves-effect waves-light',
  cancel: 'btn waves-effect waves-light retour',
  floating_large_space: 'btn-floating waves-effect waves-light btn-large btn-space',
  floating_large: 'btn-floating waves-effect waves-light btn-large',
  floating: 'btn-floating waves-effect waves-light',
  floating_space: 'btn-floating waves-effect waves-light btn-space',
  dropdown: 'btn waves-effect waves-light dropdown-button',
  space: 'btn-space',
  noBorder: 'button-no-border',
}



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/styles/buttons.js